import { render, staticRenderFns } from "./TaskToCome.vue?vue&type=template&id=51b20e82&scoped=true&"
import script from "./TaskToCome.vue?vue&type=script&lang=js&"
export * from "./TaskToCome.vue?vue&type=script&lang=js&"
import style0 from "./TaskToCome.vue?vue&type=style&index=0&id=51b20e82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b20e82",
  null
  
)

export default component.exports